function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import Image from '../../Image';
import VisibilitySensor from '../../VisibilitySensor';

var isLoaddingAttrSupported = function isLoaddingAttrSupported() {
  return 'loading' in HTMLImageElement.prototype;
};
/**
 * :lock: **PRIVATE** :lock:
 *
 * The LazyLoadedImage component is an internal component used by the Media component.
 * Do not use LazyLoadedImage directly.
 *
 * LazyLoadedImage will only load images when they are just about to be shown on screen.
 * For supported images a progressive loading treatment will be applied. When the loading attribute
 * is supported then we pass through to Image
 *
 * ## Composed of
 * - [MediaFrame](../../MediaFrame/README.md)
 * - [VisibilitySensor](../../VisibilitySensor/README.md)
 * - [Image](../../Image/README.md)
 *
 * ## Related Components
 * - [Media](../Media/README.md)
 *
 * ## Usages
 *
 * See `Media` component usage
 *
 * ## Props
 *
 * See `Image` for additional props
 */


var LazyLoadedImage = /*#__PURE__*/function (_PureComponent) {
  _inherits(LazyLoadedImage, _PureComponent);

  var _super = _createSuper(LazyLoadedImage);

  function LazyLoadedImage(props) {
    var _this;

    _classCallCheck(this, LazyLoadedImage);

    _this = _super.call(this, props);
    _this._ref = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(LazyLoadedImage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          src = _this$props.src,
          loading = _this$props.loading,
          children = _this$props.children;

      var renderImage = function renderImage(_ref) {
        var isVisible = _ref.isVisible;
        return /*#__PURE__*/React.createElement(Image, _extends({}, _this2.props, {
          src: isVisible ? src : null,
          ref: _this2._ref
        }), children);
      };

      if (Image.config.isSsr || loading === 'eager' || isLoaddingAttrSupported()) {
        return renderImage({
          isVisible: true
        });
      }

      return /*#__PURE__*/React.createElement(VisibilitySensor, {
        intersectionThreshold: 0.1,
        oneShot: true,
        element: this._ref
      }, renderImage);
    }
  }]);

  return LazyLoadedImage;
}(PureComponent);

LazyLoadedImage.defaultProps = {
  qa: '',
  className: '',
  src: undefined,
  width: undefined,
  height: undefined,
  aspectRatio: undefined,
  children: null,
  fit: undefined,
  place: undefined,
  loading: 'lazy'
};
LazyLoadedImage.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,
  loading: PropTypes.oneOf(['lazy', 'auto', 'eager']),

  /**
   * Sets the width of the image to display
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Sets the height of the image to display
   */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string,

  /**
   * How to fit the image when aspect ratios are mismatched
   * values generally follow the `background-size` css property
   * [MDN Dos on background-size](https://developer.mozilla.org/en-US/docs/Web/CSS/background-size)
   */
  fit: PropTypes.oneOf([undefined, 'fill', 'cover', 'contain']),

  /**
   * Strategy for placing the image within it's frame
   */
  place: PropTypes.oneOf(['center', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),

  /**
   * Aspect ratio to restrict the image to. Aspect ratios are defined in
   * the base styles package
   */
  aspectRatio: PropTypes.oneOf([undefined, '1:1', '4:3', '16:9', '3:2', '2:3', '3:4', '4:5', '5:6']),

  /**
   * fallback component to render on error
   */
  children: PropTypes.node
};
export default LazyLoadedImage;